<h2 mat-dialog-title>Add New Part Number</h2>

<mat-dialog-content>
  <mat-form-field appearance="fill" class="w-100 mt-3">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="data.description" placeholder="Enter description (optional)" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>No</button>
  <button mat-flat-button color="primary" (click)="confirm()">Add</button>
</mat-dialog-actions>
